import React from 'react';
import { Switch, SwitchProps } from '@mui/material';
import clsx from 'clsx';

import { useStyles } from './AppSwitch.styles';
import theme from '../../../styles/theme';

interface AppSwitchProps extends SwitchProps {
  value: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
}

export default function AppSwitch(props: AppSwitchProps) {
  const { value, onChange = () => {}, className, ...otherProps } = props;
  const { classes } = useStyles(theme);

  return (
    <Switch
      className={clsx(classes.switchWrapper, className)}
      classes={{
        root: classes.switchRoot,
        track: classes.switchTrack,
        switchBase: classes.switchBase,
        checked: classes.switchChecked,
      }}
      checked={value}
      onChange={onChange}
      {...otherProps}
    />
  );
}
